import { BareButton } from '@calendly/ui/components/bare-button';
import { BrandLogo } from '@calendly/ui/components/brand-logo';
import classNames from 'classnames';
import { useEffect, forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { TRACKING_EVENT_NAMES } from '../../hooks/analytics_events/constants';
import { useTrack } from '../../hooks/analytics_events/useTrack';
import { useBrowserName } from '../../hooks/useBrowserName';
import { googleConferencingConfiguredSelector } from '../../selectors/current_user';
import { getCtaDestination, isUnsupportedBrowser } from '../../shared/browsers/helpers';
const EXTENSION_LINKS = {
  firefox: 'https://addons.mozilla.org/en-US/firefox/addon/calendly-meeting-scheduling?utm_source=calendly' + '&utm_medium=web_app&utm_campaign=top_nav_cta&utm_content=firefox&utm_term=firefox',
  'microsoft-edge': 'https://microsoftedge.microsoft.com/addons/detail/calendly-meeting-schedul/hfngfpepejakabkhocoamdlnipilcpga?' + 'utm_source=calendly&utm_medium=web_app&utm_campaign=top_nav_cta&utm_content=edge&utm_term=edge',
  chrome: 'https://chromewebstore.google.com/detail/calendly-meeting-scheduli/cbhilkcodigmigfbnphipnnmamjfkipp?' + 'utm_source=calendly&utm_medium=web_app&utm_campaign=top_nav_cta&utm_content=chrome&utm_term=chrome'
};
const BROWSER_NAMES = {
  firefox: 'Firefox',
  'microsoft-edge': 'Microsoft Edge',
  chrome: 'Google Chrome'
};

// Two logo components are required because dynamic expression compilation is disabled for this app
const browserLogoCss = "b1yj497p";
const BrowserLogo = forwardRef((props, ref) => <BrandLogo ref={ref} {...props} className={classNames(browserLogoCss, props.className)} />);
const gmailLogoCss = "g4k25c2";
const GmailLogo = forwardRef((props, ref) => {
  const name = 'gmail';
  return <BrandLogo ref={ref} {...props} name={name} className={classNames(gmailLogoCss, props.className)} />;
});
const styledButtonCss = "sm00c06";
const StyledButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(styledButtonCss, props.className)} />);
export const ExtensionDownloadCta = props => {
  const {
    promo
  } = props;
  const hasGoogleCalendar = useSelector(googleConferencingConfiguredSelector);
  const track = useTrack();
  const browserName = useBrowserName();
  const ctaDestination = getCtaDestination(browserName);
  const ctaText = !promo && hasGoogleCalendar ? 'gmail_install' : 'browser_known_install';
  useEffect(() => {
    if (!isUnsupportedBrowser()) {
      track({
        name: TRACKING_EVENT_NAMES.CTA_SHOWN,
        entities: ['attribution', 'organization', 'user'],
        properties: {
          cta_text: ctaText,
          cta_key: 'header',
          cta_destination: ctaDestination
        }
      });
    }
  }, [ctaDestination, ctaText, track]);
  const onClick = () => {
    if (!isUnsupportedBrowser()) {
      track({
        name: TRACKING_EVENT_NAMES.CTA_CLICKED,
        entities: ['attribution', 'organization', 'user'],
        properties: {
          cta_text: ctaText,
          cta_key: 'header',
          cta_destination: ctaDestination
        }
      });
    }
  };
  return <StyledButton as="a" onClick={onClick} href={EXTENSION_LINKS[browserName]} target="_blank" rel="noopener noreferrer">
      {!promo && hasGoogleCalendar ? <GmailLogo /> : <BrowserLogo name={browserName} />}
      {!promo ? <>
          Schedule directly from
          {' '}
          {hasGoogleCalendar ? 'Gmail' : BROWSER_NAMES[browserName]}
        </> : 'Install our browser extension'}
    </StyledButton>;
};

require("./extension_download_cta.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./extension_download_cta.js");